import React from 'react';

import { IOlympicList, olympicConst } from 'modules/online-olympic';

import Dtm from './dtm';
import FixedSubject from './fixed-subject';
import FixedSubjects from './fixed-subjects';

interface IProps {
  type: olympicConst.OlympicTypes;
  olympic?: IOlympicList;
}

const OlympicStarted: React.FC<IProps> = ({ type, olympic }) => {
  const componentMap: Record<string, JSX.Element> = {
    [olympicConst.OlympicTypes.DTM]: <Dtm olympic={olympic} />,
    [olympicConst.OlympicTypes.FIXED_SUBJECTS]: <FixedSubjects olympic={olympic} />,
    [olympicConst.OlympicTypes.FIXED_SUBJECT]: <FixedSubject olympic={olympic} />
  };

  return componentMap[type] || null;
};

export default OlympicStarted;
